//AUTH
export const LOGIN_URL = "/login";
export const GOOGLE_AUTH = "/auth";
export const GOOGLE_CALLBACK_URL = (route: string) => `/auth/callback${route}`;
export const CREATE_USER_URL = "/register";
export const FORGOT_PASS_URL = "/forgot-password";
export const RESET_PASS_URL = "/reset-password";
// USERS
export const All_USERS_URL = "/all/users";
export const All_USERS_DAYS_OFF = "/all/users/daysoff";
export const CURRENT_USER_URL = "/user";
export const SELECTED_USER_ID_URL = (id: number) => `/users/${id}`;
export const EDIT_USER_URL = "/edit";
export const ADD_USER = "/register";
export const DELETE_USER = (id: number) => `/users/delete/${id}`;
export const EDIT_USER = (id: number) => `/users/edit/${id}`;

//SKILLS
export const ALL_SKILLS = "/all/skills";
export const SKILLS = "/skills";
export const EDIT_SKILL_URL = "/edit/skill";
export const DESTROY_SKILL_URL = (id: number) => `/skills/${id}`;
export const SKILLS_PER_USER_URL = (id: number) => `/users/${id}/skills`;
export const DELETE_CURRENT_USER_SKILLS = (userID: number, skillID: number) =>
    `/users/${userID}/skills/${skillID}`;

// FILES
export const FILES = "/files";
export const FILE_ID_URL = (id: number) => `/files/${id}`;

// HOLIDAYS
export const HOLIDAYS_URL = "/holidays";
export const HOLIDAYS_STATUS_URL = (id: number) => `/holidays/${id}`;
export const HOLIDAYS_WEEKLY = "/current_week/holidays";
export const HOLIDAYS_DATE_RANGE = "/range/holidays";
export const HOLIDAY_TYPES_URL = "/holidays/types";
export const HOLIDAYS_REQUESTS_URL = (id: number) =>
    `/holidays/requesting/${id}`;
export const ADD_TOTAL_HOLIDAYS_PER_USER = (id: number) =>
    `/users/${id}/holidays`;
export const GET_HOLIDAYS_DATELIST = (id: number, day: string) =>
    `user/${id}/holidays/day/${day}`;

// LOGS
export const LOGS_URL = "/logs";
export const WEEKLY_LOGS_URL = (
    userId: number,
    day: string,
) => `/logs/user/${userId}/from/${day}`;
export const LOGS_DATE_RANGE = "range/logs";
export const WEEKLY_LOGS = `/weekly/logs`;
export const MONTHLY_LOGS_URL = (
    userId: number,
    month: number,
    currentYear: number
) => `/logs/user/${userId}/month/${month}/year/${currentYear}`;

export const USER_REPORT = (
    userId: number,
    month: number,
    year: number
) => `/report/user/${userId}/month/${month}/year/${year}`;


export const CLIENT_MONTHLY_LOGS_URL = (
    clientId: number,
    month: number,
    currentYear: number
) => `/logs/client/${clientId}/month/${month}/year/${currentYear}`;
export const CLIENT_SHOW = (
    clientId: number,
) => `/clients/${clientId}`;
export const DELETE_LOG = (id: number) => `/logs/${id}`;

// NATIONAL HOLIDAYS
export const NATIONAL_HOLIDAYS_URL = "/national_holidays";
export const NATIONAL_HOLIDAYS_WEEKLY = "/range/national_holidays";

//DAYS AVAILABLE
export const DAYS_AVAILABLE = "/days_available";

//HOME OFFICE DAYS
export const HOME_OFFICE_DAYS = "/home_office_days";
export const HOME_OFFICE_DAYS_BY_ID = "/home_office_days/delete_by_user_id_and_date";
export const HOME_OFFICE_DAYS_PATCH = (id: number) => `/home_office_days/${id}`;

// ORGANIZATIONS
export const ORGANIZATIONS_URL = "/organizations";
export const ORGANIZATION_URL = (id: number) => `/organizations/${id}`;
export const ORGANIZATION_MONTHLY_LOGS_URL = (
    organizationId: number,
    month: number,
    currentYear: number
) => `/logs/organization/${organizationId}/month/${month}/year/${currentYear}`;
